import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";

import {
  areaReducer,
  calendarReducer,
  learnerReducer,
  userReducer,
} from "./slices";

const customizedMiddleware = [
  ...getDefaultMiddleware({
    thunk: false,
    serializableCheck: false,
  }),
];

const rootReducer = combineReducers({
  user: userReducer,
  calendar: calendarReducer,
  learner: learnerReducer,
  area: areaReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
});

export type RootState = ReturnType<typeof rootReducer>;
export type StoreDispatch = typeof store.dispatch;
